import bancoState from "./bancoState"
import cajaState from "./cajaState"
import clienteState from "./clienteState"
import codigoContableState from "./codigoContableState"
import componentsState from "./componentsState"
import proveedorState from "./proveedorState"
import sesionState from "./sesionState"
import inventoryState from "./inventoryState"
import gestionState from "./gestionState"
import personalState from "./personalState"
import subscriptionsState from "./subscriptionsState"
import compraVentaState from "./compraVentaState"
import hojasState from "./hojasState"
import serviceState from "./serviceState"

export default {
    ...bancoState,
    ...cajaState,
    ...clienteState,
    ...codigoContableState,
    ...componentsState,
    ...gestionState,
    ...proveedorState,
    ...sesionState,
    ...inventoryState,
    ...gestionState,
    ...personalState,
    ...subscriptionsState,
    ...compraVentaState,
    ...hojasState,
    ...serviceState,
}